import React from 'react';

import { Box, Text } from '../../core';

export interface Props {
  errorMessage?: string;
  successMessage?: string;
}

const FormAlert = ({ errorMessage, successMessage }: Props): JSX.Element | null => {
  let feedbackMessage: string | undefined;
  if (errorMessage) {
    feedbackMessage = errorMessage;
  } else if (successMessage) {
    feedbackMessage = successMessage;
  }

  if (!feedbackMessage) return null;

  return (
    <Box
      background={errorMessage ? 'error' : 'success'}
      borderColor={errorMessage ? 'border.error' : 'border.success'}
      borderRadius="primary"
      borderStyle="solid"
      borderWidth="2px"
      mb="6x"
      p="4x"
    >
      <Text role="alert">{feedbackMessage}</Text>
    </Box>
  );
};

export default FormAlert;
